export default function isProduction() {
  const { origin } = new URL(window.location);
  return origin === 'https://go.heepsy.com';
}
